import { PLAN_INTEREST_PATH, SIGNUP_PATH } from "@/modules/plan/copy";

export const PREPARING_LABEL = "준비 중 · 곧 공개";
// 랜딩 요금 카드의 짧은 배지(시안 V3).
export const PREPARING_SHORT_LABEL = "준비 중";
export const NOTIFY_ME_LABEL = "출시 알림 받기";

// 준비 중 요금제 버튼 — 로그인했으면 출시 알림 신청, 아니면 가입부터.
export const notifyMeHrefOf = (signedIn: boolean): string => (signedIn ? PLAN_INTEREST_PATH : SIGNUP_PATH);
